<div class="feature-explenation">
    <div class="feature-explenation_title">
        {{title}}
    </div>
    <div class="feature-explenation_text">
        {{text}}
    </div>
</div>